// client/src/ui/PageHeader/PageHeader.js
//
// M06 Fase 4 - Cabecera estandar de pagina del dashboard admin.
// Reemplaza al `<Header as="h1">` de Semantic UI heredado del admin legacy.

import React from "react";
import styles from "./PageHeader.module.scss";

export function PageHeader({ title, subtitle, actions, children }) {
  return (
    <div className={styles.pageHeader}>
      <div className={styles.titleRow}>
        <h1 className={styles.title}>{title}</h1>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
      {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      {children}
    </div>
  );
}
